export default __webpack_public_path__ + "static/media/iso3.c0bcdb45.png";